import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { FragmentMessages } from "../../common/fragment-messages";
import PatResultType from "../enums/pat-result-type";

export default class FieldGoalBlocked extends Fragment {
    constructor(kickedTo, blockedBy) {
        super();
        this.code = "B";
        this.patCode = PatResultType.BLOCKED.code;
        this.kickedTo = kickedTo;
        this.blockedBy = blockedBy;

        this.requiredData = [
            {
                name: "kickedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Kicked To",
                title: "Kicked To",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            },
            {
                name: "blockedBy",
                appliesToOpponent: () => true,
                type: FragmentDataType.Player,
                displayName: "Blocked By",
                title: (team) => `Blocked By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.blockedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = ` for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.kickedTo,
            false
        )} blocked by ${stringifier.firstInitial(this.blockedBy)}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.kickedTo;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
